<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="40">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="场次">
                            <c-input name="auction_batch_no"></c-input>
                        </m-search-item>
                        <m-search-item label="报告时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <c-table-column type="button" label="操作" width="80" fixed="right">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="$refs.detail.open(data)">详情</c-table-button>
                    </template>
                </c-table-column>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #channel_summary_json="{data}">
                    <span v-for="(item, index) in parseSummary(data.channel_summary_json)" :key="index" class="m-channel-item">
                        <span>{{item.channel_name}}(</span><span style="color: #19be6b;">{{item.success}}</span><span style="color: #ed3f14;">/{{item.fail}}</span><span>/{{item.total}})</span>
                    </span>
                    <span v-if="!parseSummary(data.channel_summary_json).length">-</span>
                </template>
            </view-list>
            <erp-auction-push-report-detail ref="detail"></erp-auction-push-report-detail>
        </module>
    </page>
</template>

<script>
import ErpAuctionPushReportDetail from './components/auction_push_report_detail.vue';

export default {
    name: 'erp_auction_push_report',
    components: {ErpAuctionPushReportDetail},
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        parseSummary(json) {
            try {
                var list = JSON.parse(json || '[]');
                return Array.isArray(list) ? list : [];
            } catch (e) {
                return [];
            }
        }
    }
};
</script>

<style scoped>
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
.m-channel-item {display: inline-block; margin-right: 16px; white-space: nowrap;}
</style>
